<button type="button" (click)="cancelCard()" class="acc-back">&lsaquo; Back to customer</button>

<payarc-page-header title="Add Card" subtitle="Save a card on file for this customer to charge or subscribe later."></payarc-page-header>

<payarc-inline-alert class="acc-alert">Card data is captured over a secure, PCI-compliant field. Only the last 4 digits are stored and shown.</payarc-inline-alert>

<ng-container *ngIf="topErrorMessage">
  <p class="acc-top-error" *ngFor="let obj of keys1">
    <ng-container *ngFor="let value of obj">{{value}}</ng-container>
  </p>
</ng-container>
<p class="acc-top-error" *ngIf="!topErrorMessage && errorMsgFlag && errorMsg">{{errorMsg}}</p>

<form [formGroup]="demoForm" (ngSubmit)="demoForm.valid && addCard()">
  <app-customer-add-card-details-section #addCardForm cardSectionHeading="Card details" (onFormGroupChange)="setChildForm($event)"
    [customerCard]="customerCard" (onCustomerCardChange)="customerCard" (onCvvError)="cvcError = $event">
  </app-customer-add-card-details-section>
</form>

<div class="form-footer">
  <button type="button" payarcButton="secondary" (click)="cancelCard()">Cancel</button>
  <app-loading-button (buttonClick)="childSubmit()" [loadFlag]="loadFlag" [buttonText]="'Add card'"></app-loading-button>
</div>
